import {pageInfo, executeQcSpot, cancel} from '../api';
import {goodsCategory, plant, deviceQc} from "../../../../../api";

const qcSpot = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    executeQcSpotObj: null,
    deviceQcObj: null,
    cancelObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true, item.reqStatusCode == '00' ? true : false]}));
    },
    GOODS_CATEGORY(state, data) {
      state.goodsCategoryObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    EXECUTE_QCSPOT(state, data){
      state.executeQcSpotObj = data;
    },
    DEVICE_QC(state, data) {
      state.deviceQcObj = data.obj;
    },
    CANCEL(state, data){
      state.cancelObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async goodsCategory({commit}, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async executeQcSpot({commit}, obj){
      let result = await executeQcSpot(obj);
      commit('EXECUTE_QCSPOT', result);
    },
    async deviceQc({commit}, obj) {
      let resp = await deviceQc(obj);
      commit('DEVICE_QC', resp);
    },
    async cancel({commit}, obj) {
      let resp = await cancel(obj);
      commit('CANCEL', resp);
    },
  }
}
export default qcSpot



// WEBPACK FOOTER //
// ./src/page/bd/qc/qcSpot/store/qcSpot.store.js